import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/homework-sources/HomeworkSourcesAction";
import * as uiHelpers from "../HomeworkSourcesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useHomeworkSourcesUIContext } from "../HomeworkSourcesUIContext";

export function HomeworkSourcesTable({ 
  deleteHomeworkSources
}) {
  // Homework Sources UI Context
  const sourcesUIContext = useHomeworkSourcesUIContext();
  const sourcesUIProps = useMemo(() => {
    return {
      ids: sourcesUIContext.ids,
      setIds: sourcesUIContext.setIds,
      queryParams: sourcesUIContext.queryParams,
      setQueryParams: sourcesUIContext.setQueryParams,
      openEditHomeworkSourcePage: sourcesUIContext.openEditHomeworkSourcePage
    };
  }, [sourcesUIContext]);

  // Getting curret state of Homework Sourses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.homeworkSources }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Homework Sourses Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getHomeworkSources(sourcesUIProps.queryParams));
    return () => dispatch(actions.cleanHomeworkSourcesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourcesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: "Kaynak Adı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "pageNumber",
      text: "Sayfa Numarası",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        isEditionAuthorized,
        isDeletionAuthorized,
        openEditHomeworkSourcePage: sourcesUIProps.openEditHomeworkSourcePage,
        deleteHomeworkSources
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: sourcesUIProps.queryParams.pageSize,
    page: sourcesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                sourcesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: sourcesUIProps.ids,
                setIds: sourcesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}